<template>
  <div class="section-header">
    <p class="subtitle">{{ subtitle }}</p>
    <h2 class="title">{{ title }}</h2>
  </div>
</template>

<script>
export default {
  name: "SectionHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" }
  }
};
</script>

<style scoped>
.section-header {
  text-align: center;
  margin-bottom: 4rem;
}
.section-header .subtitle {
  color: var(--primary-red);
  font-weight: 700;
  margin-bottom: 0.5rem;
}
.section-header .title {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--primary-blue);
}
</style>
